<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 4.13867H0V19.8887H24V4.13867Z" fill="white" />
  <path
    d="M14.2969 8.5548C12.3937 7.28917 9.82499 7.8048 8.55937 9.70323C7.92187 10.6501 8.18437 11.9392 9.13124 12.572C10.0828 13.2048 11.3625 12.947 12 11.9954C12.6328 11.0439 13.9172 10.7907 14.8687 11.4189C15.8203 12.0517 16.0781 13.3407 15.4406 14.2876C16.7109 12.3939 16.1953 9.82511 14.2969 8.5548Z"
    fill="#C60C30"
  />
  <path
    d="M8.55919 9.70312C7.92169 10.65 8.18419 11.9391 9.13107 12.5719C10.0826 13.2047 11.3623 12.9469 11.9998 11.9953C12.6326 11.0437 13.917 10.7906 14.8686 11.4188C15.8201 12.0516 16.0779 13.3406 15.4404 14.2875C14.1748 16.1906 11.6061 16.7016 9.70763 15.4359C7.80919 14.175 7.29357 11.6063 8.55919 9.70312Z"
    fill="#00347B"
  />
  <path
    d="M16.4015 6.99338L17.1515 8.12307C17.2124 8.21682 17.189 8.34807 17.0952 8.40901L16.9031 8.53557C16.8093 8.6012 16.6781 8.57307 16.6171 8.47932L15.8624 7.34963C15.7968 7.25588 15.8249 7.12463 15.9187 7.06369L16.1109 6.93713C16.2093 6.87151 16.3406 6.89963 16.4015 6.99338Z"
    fill="black"
  />
  <path
    d="M17.5641 8.73778L18.3188 9.86747C18.3844 9.96122 18.3563 10.0925 18.2625 10.1534L18.0703 10.28C17.9766 10.3409 17.8453 10.3175 17.7844 10.2237L17.025 9.09403C16.9594 9.00028 16.9875 8.86903 17.0813 8.8081L17.2735 8.68153C17.3719 8.61591 17.4985 8.63935 17.5641 8.73778Z"
    fill="black"
  />
  <path
    d="M17.2078 6.45421L19.1203 9.32765C19.186 9.4214 19.1578 9.55265 19.0641 9.61358L18.8719 9.74015C18.7781 9.80577 18.6469 9.77765 18.586 9.6839L16.6735 6.81046C16.6078 6.71671 16.636 6.58546 16.7297 6.52452L16.9219 6.39796C17.0156 6.33702 17.1422 6.36046 17.2078 6.45421Z"
    fill="black"
  />
  <path
    d="M18.0096 5.92014L18.7643 7.04983C18.8299 7.14358 18.8018 7.27483 18.708 7.33577L18.5158 7.46233C18.4221 7.52327 18.2908 7.49983 18.2299 7.40608L17.4752 6.27639C17.4096 6.18264 17.4377 6.05139 17.5315 5.99045L17.7237 5.86389C17.8174 5.79827 17.9487 5.82639 18.0096 5.92014Z"
    fill="black"
  />
  <path
    d="M19.1721 7.66417L19.9221 8.79386C19.9877 8.88761 19.9596 9.01886 19.8658 9.0798L19.6736 9.20636C19.5799 9.27198 19.4486 9.24386 19.3877 9.15011L18.6377 8.02042C18.5768 7.92667 18.6002 7.79542 18.694 7.73448L18.8861 7.60792C18.9799 7.54698 19.1065 7.57042 19.1721 7.66417Z"
    fill="black"
  />
  <path
    d="M6.22053 13.7815L8.13303 16.6502C8.19866 16.744 8.17053 16.8752 8.07678 16.9362L7.88459 17.0627C7.79084 17.1283 7.65959 17.1002 7.59866 17.0065L5.68616 14.1377C5.62053 14.044 5.64866 13.9127 5.74241 13.8518L5.93459 13.7252C6.02834 13.6596 6.15959 13.6877 6.22053 13.7815Z"
    fill="black"
  />
  <path
    d="M5.41877 14.3155L6.16877 15.4405C6.2344 15.5343 6.20627 15.6655 6.11252 15.7265L5.92034 15.853C5.82659 15.9187 5.69534 15.8905 5.6344 15.7968L4.8844 14.6718C4.81877 14.578 4.8469 14.4468 4.94065 14.3858L5.13284 14.2593C5.22659 14.1984 5.35315 14.2218 5.41877 14.3155Z"
    fill="black"
  />
  <path
    d="M6.58118 16.0588L7.33118 17.1885C7.3968 17.2823 7.36868 17.4135 7.27493 17.4744L7.08274 17.601C6.98899 17.6666 6.85774 17.6385 6.7968 17.5447L6.04211 16.4151C5.97649 16.3213 6.00461 16.1901 6.09836 16.1291L6.29055 16.0026C6.38899 15.9369 6.51555 15.9651 6.58118 16.0588Z"
    fill="black"
  />
  <path
    d="M4.61262 14.855L6.52512 17.7237C6.59075 17.8175 6.56262 17.9487 6.46887 18.0097L6.27668 18.1362C6.18293 18.2018 6.05168 18.1737 5.99075 18.08L4.07825 15.2112C4.01262 15.1175 4.04075 14.9862 4.1345 14.9253L4.32668 14.7987C4.42043 14.7331 4.55168 14.7565 4.61262 14.855Z"
    fill="black"
  />
  <path
    d="M5.68616 9.86194L7.59866 6.9885C7.66428 6.89475 7.79084 6.86662 7.88459 6.93225L8.07678 7.05881C8.17053 7.12444 8.19866 7.251 8.13303 7.34475L6.22053 10.2182C6.15491 10.3119 6.02834 10.3401 5.93459 10.2744L5.74241 10.1479C5.64866 10.0869 5.62053 9.96037 5.68616 9.86194Z"
    fill="black"
  />
  <path
    d="M4.87989 9.32776L6.79239 6.45432C6.85802 6.36057 6.98458 6.33245 7.07833 6.39807L7.27052 6.52463C7.36427 6.59026 7.39239 6.71682 7.32677 6.81057L5.41427 9.68401C5.34864 9.77776 5.22208 9.80588 5.12833 9.74026L4.93614 9.6137C4.84239 9.55276 4.81896 9.42151 4.87989 9.32776Z"
    fill="black"
  />
  <path
    d="M4.07825 8.79358L5.99075 5.92014C6.05637 5.82639 6.18293 5.79827 6.27668 5.86389L6.46887 5.99045C6.56262 6.05608 6.59075 6.18264 6.52512 6.27639L4.61262 9.14983C4.547 9.24358 4.42043 9.2717 4.32668 9.20608L4.1345 9.07952C4.04075 9.01858 4.01262 8.89202 4.07825 8.79358Z"
    fill="black"
  />
  <path
    d="M15.8673 16.6496L16.6173 15.5246C16.6829 15.4309 16.8095 15.4028 16.9032 15.4684L17.0954 15.5949C17.1892 15.6606 17.2173 15.7871 17.1517 15.8809L16.4017 17.0059C16.3361 17.0996 16.2095 17.1278 16.1157 17.0621L15.9236 16.9356C15.8298 16.8746 15.8017 16.7434 15.8673 16.6496Z"
    fill="black"
  />
  <path
    d="M17.0249 14.911L17.7796 13.7766C17.8452 13.6828 17.9718 13.6547 18.0655 13.7203L18.2577 13.8469C18.3515 13.9125 18.3796 14.0391 18.314 14.1328L17.5593 15.2625C17.4937 15.3563 17.3671 15.3844 17.2734 15.3188L17.0812 15.1922C16.9874 15.136 16.964 15.0094 17.0249 14.911Z"
    fill="black"
  />
  <path
    d="M16.6687 17.1885L17.4234 16.0588C17.489 15.9651 17.6156 15.9369 17.7093 16.0026L17.9015 16.1291C17.9953 16.1948 18.0234 16.3213 17.9578 16.4151L17.2078 17.5447C17.1422 17.6385 17.0156 17.6666 16.9218 17.601L16.7297 17.4744C16.6312 17.4135 16.6078 17.2823 16.6687 17.1885Z"
    fill="black"
  />
  <path
    d="M17.8312 15.4455L18.5859 14.3205C18.6515 14.2268 18.7781 14.1987 18.8718 14.2643L19.064 14.3908C19.1577 14.4565 19.1859 14.583 19.1202 14.6768L18.3656 15.8018C18.2999 15.8955 18.1734 15.9237 18.0796 15.858L17.8874 15.7315C17.7937 15.6658 17.7656 15.5393 17.8312 15.4455Z"
    fill="black"
  />
  <path
    d="M17.4752 17.7237L18.2299 16.594C18.2955 16.5002 18.4221 16.4721 18.5158 16.5377L18.708 16.6643C18.8018 16.7252 18.8299 16.8565 18.7643 16.9502L18.0096 18.0799C17.944 18.1737 17.8174 18.2018 17.7237 18.1362L17.5315 18.0096C17.4377 17.9487 17.4096 17.8174 17.4752 17.7237Z"
    fill="black"
  />
  <path
    d="M18.6378 15.9844L19.3878 14.8547C19.4534 14.761 19.58 14.7328 19.6738 14.7985L19.8659 14.925C19.9597 14.9906 19.9878 15.1172 19.9222 15.211L19.1722 16.3406C19.1113 16.4344 18.98 16.4625 18.8863 16.3969L18.6941 16.2703C18.6003 16.2047 18.5722 16.0781 18.6378 15.9844Z"
    fill="black"
  />
</svg>
